export default "__VITE_ASSET__BYyVX33w__"